import { createSlice } from "@reduxjs/toolkit";
import { MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY } from "./projectDetailData";

let { SURVEY_DESIGN_SUPPORT: SURVEY_DESIGN_SUPPORT, SURVEY_PROGRAMMING, TRANSLATION, DASHBOARD, DATA_ANALYSIS, DATA_COLLECTION, REPORTS } = MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY

const initialState = {
  [SURVEY_DESIGN_SUPPORT]: {
    data: [],
    response: false,
    approved: false,
    toBeSharedData: null,
    isQuestionnaireShared: false,
    implementChangesAction: false
  },
  [SURVEY_PROGRAMMING]: {
    response: false,
    approved: false
  },
  [TRANSLATION]: {
    response: false,
    approved: false
  },
  [DATA_COLLECTION]: {
    response: false,
    approved: false
  },
  [DATA_ANALYSIS]: {
    response: false,
    approved: false
  },
  [DASHBOARD]: {
    response: false,
    approved: false
  },
  [REPORTS]: {
    response: false,
    approved: false
  },
  nextStep: null
};
export const sliceName = 'projectDetailMarketResearchFullService'


export const ProjectDetailMarketResearchFullService = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setQuestionnaireSupport: (state, action) => {
      state[SURVEY_DESIGN_SUPPORT].data = action.payload
    },
    setNextStep: (state, action) => {
      state.nextStep = action.payload
    },
    setResponse: (state, { payload: { id, value } }) => {
      state[id].response = value
    },
    setApproval: (state, { payload: { id, value } }) => {
      state[id].approved = value
    },
    handleRemoveFile: (state, action) => {
      const { identifier, index } = action.payload
      state[identifier].data.splice(index, 1)
    }

  },
});

export const {
  setQuestionnaireSupport,
  setNextStep,
  setResponse,
  setApproval,
  handleRemoveFile
} = ProjectDetailMarketResearchFullService.actions;

export const selectAllSteps = state => state[sliceName]
export const selectSurveyDesignSupport = state => state[sliceName][SURVEY_DESIGN_SUPPORT]
export const selectQuestionnaireSupportApproval = state => state[sliceName][SURVEY_DESIGN_SUPPORT].approved
export const selectNextStep = state => state[sliceName].nextStep
export const selectSurveyProgramming = state => state[sliceName][SURVEY_PROGRAMMING]
export const selectTranslation = state => state[sliceName][TRANSLATION]
export const selectDataAnalysis = state => state[sliceName][DATA_ANALYSIS]
export const selectDashboard = state => state[sliceName][DASHBOARD]
export const selectReports = state => state[sliceName][REPORTS]


export default ProjectDetailMarketResearchFullService.reducer;
